import * as client from "../../services/client";
import { TYPES } from "../../common/constants";
import { store } from "..";
import { toast } from 'react-toastify';

const startLoadingDownloadServiceRequestList = () => ({
  type: TYPES.START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV,
});
export const clearLoadingDownloadServiceRequestList = () => ({
  type: TYPES.CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV,
});

const stopLoadingDownloadServiceRequestList = () => ({
  type: TYPES.STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV,
});

const fetchDownloadServiceRequestListCSVDone = (payload) => ({
  type: TYPES.FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE,
  payload,
});

const setMainServiceRequestPDFDownloadList = (payload) => ({
  type: TYPES.SET_MAIN_SERVICE_REQUEST_PDF_DOWNLOAD_LIST,
  payload,
});

export const fetchMainServiceRequestCSVExportDownloadList =
  (id, role, status, days, searchString, filterValues) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());

    let params = "";
    if (filterValues?.startDate) params += `/${filterValues.startDate}`;
    else params += "/ ";
    if (filterValues?.endDate) params += `/${filterValues.endDate}`;
    else params += "/ ";
    if (filterValues?.project) params += `/${filterValues.project}`;
    else params += "/ ";
    if (filterValues?.suite&& filterValues?.suite.length > 0) {
      let suite=filterValues?.suite;
      const ids = suite.map(({
        Id
      }) => Id).join('&')      
       params += `/${ids}`;      
    }
    else {
      params += "/ ";
    }
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
    {
      let withoutWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data!=='One Year Warranty Issue' && data!=='Internal' && data!=='Homeowner or Occupant' && data!=='Group'
      );
      params += withoutWarrantyIssueStatus.length>0?`/${withoutWarrantyIssueStatus}`:'/ ';
    }
    else{params += "/ ";}
    if (filterValues?.issueType) params += `/${filterValues.issueType}`;
    else params += "/ ";
    if (filterValues?.assetType) params += `/${filterValues.assetType}`;
    else params += "/ ";
    if (filterValues?.building) params += `/${filterValues.building}`;
    else params += "/ ";
    if (filterValues?.level) params += `/${filterValues.level}`;
    else params += "/ ";
    if (filterValues?.assignTo) params += `/${filterValues.assignTo}`;
    else params += "/ ";
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
    {
      let withWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data==='One Year Warranty Issue'
      );
      params += withWarrantyIssueStatus.length>0?`/${true}`:"/ ";
    }
    else{params += "/ ";}

       // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3129
      // Comment: Added ServiceRequest Filter - as Internal and Homeowner or Occupant.
 
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
    {
      let internal = filterValues.walkthrough.filter(
        (data) => data==='Internal'
      );
      let homeOwnerOrOccupant = filterValues.walkthrough.filter(
        (data) => data==='Homeowner or Occupant'
      );
      if(internal.length>0 || homeOwnerOrOccupant.length>0){
        if(internal.length>0 && homeOwnerOrOccupant.length>0)
        {
          params += `/Internal,Homeowner or Occupant`;
        }else if(internal.length>0)
        {
          params += `/Internal`;
        }
        else if(homeOwnerOrOccupant.length>0)
        {
          params += `/Homeowner or Occupant`;
        }
      }else{params += "/ ";}
    }else{params += "/ ";}
 
     // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3111
      // Comment: All Tenants: added checkbox to show only active or closed service requests.
 
    params += `/${store.getState().serviceRequestsByGroup.displayClosedAndResolvedTickets}`;
    
      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 14/09/2022
      // Jira ticket: JUN-3187
      // Comment: Now user can download Srs as per group filter.
      
      if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
      {
        let withWarrantyIssueStatus = filterValues.walkthrough.filter(
          (data) => data==='Group'
        );
        params += withWarrantyIssueStatus.length>0?`/${true}`:"/ ";
      }
      else{params += "/ ";}
      if (filterValues?.commonAreas) params += `/${filterValues.commonAreas}`;
      else params += "/ ";

      if (filterValues?.tags&& filterValues?.tags.length > 0) {
        let tags=filterValues?.tags;
        const ids = tags.map(({
          value
        }) => value).join('&')      
         params += `/${ids}`;      
      }
      else {
        params += "/ ";
      }
      
    if (searchString) params += `/${searchString}`;
    else params += "/ ";

    return client
      .fetchMainServiceRequestCSVExportDownloadList(id, role, status, days, params)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
              let tempSrsList= responsejson.serviceRequestList;
              let srsList= tempSrsList.map((item)=>{
                if(item.attachment){
                  let imageLinks = JSON.parse(item.attachment)
                  return(
                  {  ...item,
                    attachmentLinks : imageLinks.toString()}
                  )  
                }else{
                  return(
                    {  ...item,
                      attachmentLinks : item.attachment}
                    )  
                }
               });
              dispatch(fetchDownloadServiceRequestListCSVDone(srsList));
              dispatch(stopLoadingDownloadServiceRequestList());
          })
        } else {
          dispatch(stopLoadingDownloadServiceRequestList())
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

  export const fetchSelectedServiceRequestCSVExportDownloadList =
  (params) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());

    return client
      .fetchSelectedServiceRequestCSVExportDownloadList(params)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
              dispatch(fetchDownloadServiceRequestListCSVDone(responsejson.serviceRequestList));
              dispatch(stopLoadingDownloadServiceRequestList());
          })
        } else {
          dispatch(stopLoadingDownloadServiceRequestList())
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

  export const fetchMainServiceRequestPDFExportDownloadList =
  (id, role, status, days, searchString, filterValues) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());

    let params = "";
    if (filterValues?.startDate) params += `/${filterValues.startDate}`;
    else params += "/ ";
    if (filterValues?.endDate) params += `/${filterValues.endDate}`;
    else params += "/ ";
    if (filterValues?.project) params += `/${filterValues.project}`;
    else params += "/ ";
    if (filterValues?.suite&& filterValues?.suite.length > 0) {
      let suite=filterValues?.suite;
      const ids = suite.map(({
        Id
      }) => Id).join('&')      
       params += `/${ids}`;      
    }
    else {
      params += "/ ";
    }
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
    {
      let withoutWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data!=='One Year Warranty Issue' && data!=='Internal' && data!=='Homeowner or Occupant' && data!=='Group'
      );
      params += withoutWarrantyIssueStatus.length>0?`/${withoutWarrantyIssueStatus}`:'/ ';
    }
    else{params += "/ ";}
    if (filterValues?.issueType) params += `/${filterValues.issueType}`;
    else params += "/ ";
    if (filterValues?.assetType) params += `/${filterValues.assetType}`;
    else params += "/ ";
    if (filterValues?.building) params += `/${filterValues.building}`;
    else params += "/ ";
    if (filterValues?.level) params += `/${filterValues.level}`;
    else params += "/ ";
    if (filterValues?.assignTo) params += `/${filterValues.assignTo}`;
    else params += "/ ";
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
    {
      let withWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data==='One Year Warranty Issue'
      );
      params += withWarrantyIssueStatus.length>0?`/${true}`:"/ ";
    }
    else{params += "/ ";}

       // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3129
      // Comment: Added ServiceRequest Filter - as Internal and Homeowner or Occupant.
 
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
    {
      let internal = filterValues.walkthrough.filter(
        (data) => data==='Internal'
      );
      let homeOwnerOrOccupant = filterValues.walkthrough.filter(
        (data) => data==='Homeowner or Occupant'
      );
      if(internal.length>0 || homeOwnerOrOccupant.length>0){
        if(internal.length>0 && homeOwnerOrOccupant.length>0)
        {
          params += `/Internal,Homeowner or Occupant`;
        }else if(internal.length>0)
        {
          params += `/Internal`;
        }
        else if(homeOwnerOrOccupant.length>0)
        {
          params += `/Homeowner or Occupant`;
        }
      }else{params += "/ ";}
    }else{params += "/ ";}
 
     // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3111
      // Comment: All Tenants: added checkbox to show only active or closed service requests.
 
    params += `/${store.getState().serviceRequestsByGroup.displayClosedAndResolvedTickets}`;
    
      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 14/09/2022
      // Jira ticket: JUN-3187
      // Comment: Now user can download Srs as per group filter.
      
      if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0)
      {
        let withWarrantyIssueStatus = filterValues.walkthrough.filter(
          (data) => data==='Group'
        );
        params += withWarrantyIssueStatus.length>0?`/${true}`:"/ ";
      }
      else{params += "/ ";}

      if (filterValues?.commonAreas) params += `/${filterValues.commonAreas}`;
      else params += "/ ";

      if (filterValues?.tags&& filterValues?.tags.length > 0) {
        let tags=filterValues?.tags;
        const ids = tags.map(({
          value
        }) => value).join('&')      
         params += `/${ids}`;      
      }
      else {
        params += "/ ";
      }
      
    if (searchString) params += `/${searchString}`;
    else params += "/ ";

    return client
      .fetchMainServiceRequestPDFExportDownloadList(id, role, status, days, params)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
              toast.success('ⓘ We received your request to download the service request report. This is will take some time to process. Please check the Download PDF Requests section in a few minutes from where you’ll be able to download the file from.',{autoClose:10000,position:'top-center'})
              dispatch(stopLoadingDownloadServiceRequestList());
          })
        } else {
          toast.error(' 🚫 Something went wrong with exporting of service request PDF, please try again.',{autoClose:12000,position:'top-center'})
          dispatch(stopLoadingDownloadServiceRequestList())
        }
      }).catch(() => {
        toast.error(' 🚫 Something went wrong with exporting of service request PDF, please try again.',{autoClose:12000,position:'top-center'})
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 08/11/2022
      // Jira ticket: JUN-3364
      // Comment: Now user can download selected SRs PDF.
  export const fetchSelectedServiceRequestPDFExportDownloadList =
  (id, params) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());

    return client
      .fetchSelectedServiceRequestPDFExportDownloadList(id, params)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
              toast.success('ⓘ We received your request to download the service request report. This is will take some time to process. Please check the Download PDF Requests section in a few minutes from where you’ll be able to download the file from.',{autoClose:10000,position:'top-center'})
              dispatch(stopLoadingDownloadServiceRequestList());
          })
        } else {
          toast.error(' 🚫 Something went wrong with exporting of service request PDF, please try again.',{autoClose:12000,position:'top-center'})
          dispatch(stopLoadingDownloadServiceRequestList())
        }
      }).catch(() => {
        toast.error(' 🚫 Something went wrong with exporting of service request PDF, please try again.',{autoClose:12000,position:'top-center'})
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

  export const fetchMainServiceRequestPDFDownloadList =
  (id) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchMainServiceRequestPDFDownloadList(id)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
              dispatch(setMainServiceRequestPDFDownloadList(responsejson.data));
              dispatch(stopLoadingDownloadServiceRequestList());
          })
        } else {
          dispatch(stopLoadingDownloadServiceRequestList())
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

export const fetchPropertyServiceRequestCSVExportDownloadList =
  (propertyId, userId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchPropertyServiceRequestCSVExportDownloadList(
        propertyId,
        userId,
        role,
        searchString
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

export const fetchSuiteServiceRequestCSVExportDownloadList =
  (suiteId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchSuiteServiceRequestCSVExportDownloadList(suiteId, role, searchString)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

export const fetchContactServiceRequestCSVExportDownloadList =
  (userId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchContactServiceRequestCSVExportDownloadList(userId, role, searchString)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

export const fetchCatalogItemServiceRequestCSVExportDownloadList =
  (itemId, userId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchCatalogItemServiceRequestCSVExportDownloadList(itemId, userId, role, searchString)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };

export const fetchCommonAreaServiceRequestCSVExportDownloadList =
  (commonAreaId, role, searchString) => (dispatch) => {
    dispatch(startLoadingDownloadServiceRequestList());
    return client
      .fetchCommonAreaServiceRequestCSVExportDownloadList(commonAreaId, role, searchString)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              fetchDownloadServiceRequestListCSVDone(
                responsejson.serviceRequestList
              )
            );
            dispatch(stopLoadingDownloadServiceRequestList());
          });
        } else {
          dispatch(stopLoadingDownloadServiceRequestList());
        }
      }).catch(() => {
        dispatch(stopLoadingDownloadServiceRequestList());
      })
  };
